import React, { useCallback } from "react";
import { connect } from "react-redux";
import TabPanel, { Item as TabPanelItem } from "devextreme-react/tab-panel";
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import DateBox from 'devextreme-react/date-box';
import TextArea from 'devextreme-react/text-area';
import Accordion from 'devextreme-react/accordion';
import { CheckBox } from "devextreme-react/check-box";
import { alert } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { confirm } from "devextreme/ui/dialog";
import { LoadPanel as DivLoadPanel } from 'devextreme-react/load-panel';
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import { GridLayout } from "../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    Editing,
    ColumnFixing,
    StateStoring,
    Toolbar,
    Item,
    Selection,
    Scrolling,
} from "devextreme-react/data-grid";
import ToolbarHdr, { Item as ItemHdr } from "devextreme-react/toolbar";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { GetFormatedDateWithTime } from '../../../common/Utils';

let accessToken = '';
let oidc = '';
const shipmentCustomerSelectBox = React.createRef();
const shipmentShipperSelectBox = React.createRef();
const shipmentConsigneeSelectBox = React.createRef();
const shipmentStageSelectBox = React.createRef();
const shipmentStatusSelectBox = React.createRef();
const shipmentRateSchdSelectBox = React.createRef();

const receiptDatabaseSelectBox = React.createRef();
const receiptCompanyidSelectBox = React.createRef();
const receiptProfileSelectBox = React.createRef();
const receiptCustomerSelectBox = React.createRef();
const receiptShipperSelectBox = React.createRef();
const receiptConsigneeSelectBox = React.createRef();
const receiptStageSelectBox = React.createRef();
const receiptStatusSelectBox = React.createRef();
const receiptRateSchdSelectBox = React.createRef();
const receiptItemProfileSelectBox = React.createRef();

let detailOTItemDataGrid = React.createRef();
const detailGridKey = "a6a411bc-b411-4403-aba1-3ad4f6d130c6";

class OwnershipTransferInternal extends React.Component {
    constructor(props) {
        super(props);
        oidc = props.oidc;
        accessToken = props.oidc.user.access_token;
        this.ShipmentFormValuesChanged = this.ShipmentFormValuesChanged.bind(this);
        this.ShipmentProfileChanged = this.ShipmentProfileChanged.bind(this);
        this.ShipmentCustomerChanged = this.ShipmentCustomerChanged.bind(this);
        this.ReceiptFormValuesChanged = this.ReceiptFormValuesChanged.bind(this);
        this.ReceiptCustomerValuesChanged = this.ReceiptCustomerValuesChanged.bind(this);
        this.DetailGridselectionChanged = this.DetailGridselectionChanged.bind(this);
        this.DatabaseValueChanged = this.DatabaseValueChanged.bind(this);
        this.CompanyIdValueChanged = this.CompanyIdValueChanged.bind(this);
        this.AccordionSelectionChanged = this.AccordionSelectionChanged.bind(this);
        this.onTabSelectionChanged = this.onTabSelectionChanged.bind(this);
        this.onShipmentClickNext = this.onShipmentClickNext.bind(this);
        this.onReceiptClickNext = this.onReceiptClickNext.bind(this);
        this.ReceiptProfileChanged = this.ReceiptProfileChanged.bind(this);
        this.SearchGridFilter = this.SearchGridFilter.bind(this);
        this.ResetGridFilter = this.ResetGridFilter.bind(this);
        this.LoadItemsGrid = this.LoadItemsGrid.bind(this);
        this.onEditorPreparing = this.onEditorPreparing.bind(this);
        this.onSelectedRowKeysChange = this.onSelectedRowKeysChange.bind(this);
        this.onApplyClick = this.onApplyClick.bind(this);
        this.ResetAll = this.ResetAll.bind(this);

        this.searchpanel = [
            {
                ID: 1,
                Title: 'Filter'
            }
        ];
        const baseTransaction = {
            profileId: "",
            customerId: "",
            transDate: new Date(),
            transactionNo: "",
            shipperId: "",
            consigneeId: "",
            stage: "P",
            status: "O",
            shipperBolNo: "",
            poReference: "",
            rateScheduleId: "",
            transGroup: "",
            comment: "",
        };
        this.initialState = {
            selectedItems: [this.searchpanel[0]],
            currentLayout: "Default",
            searchPanelStatus: true,
            loadIndicatorVisible: false,
            selectedTabIndex: 0,
            isTabDisabled: true,
            isReceiptTabLoaded: false,
            isInventoryTabLoaded: false,
            shipment: {
                ...baseTransaction,
                arrShipmentProfile: [],
                shipDate: new Date(),
                shipmentDisabled: true
            },
            receipt: {
                ...baseTransaction,
                databaseId: "",
                companyId: "",
                dbid: "",
                recvDate: new Date(),
                itemProfileId: "",
                transferUnspecifiedSerialNumbers: false,
                receiptDisabled: true
            },
            inventorySelection: {
                detailTransferQuantityCount: 0,
                ItemsGridDataFilterCriteria: {
                    Itemcodefrom: "",
                    Itemcodeto: "",
                    Lotcodefrom: "",
                    Lotcodeto: "",
                    Itemdescfrom: "",
                    Itemdescto: "",
                    Lotdescfrom: "",
                    Lotdescto: "",
                },
                selectedRowKeys: [],
                itemGridArr: [],
                selectedgriditems: [],
            }
        }
        this.state = this.initialState;

        this.arrStage = [
            { id: 1, name: 'Completed/Loaded/Put Away/Transferred/Adjusted - Effects Available', value: 'C' },
            { id: 2, name: 'Future Order - No Effect On Net Available, No Charges', value: 'F' },
            { id: 3, name: 'Pending - Effects Net Available, No Charges', value: 'N' },
            { id: 4, name: 'Plan - No Inventory Effect, No Charges', value: 'P' },
            { id: 5, name: 'Ready To Receive/Pick/Staged - Effects Available, No Charges', value: 'R' }
        ];
        this.arrStatus = [
            { id: 1, name: 'Hold', value: 'H' },
            { id: 2, name: 'Ready To Commit Later', value: 'L' },
            { id: 3, name: 'Open', value: 'O' },
            { id: 4, name: 'Commited', value: 'Z' },
        ];
    }
    setCurrentLayout = (value) => {
        this.setState({
            currentLayout: value
        });
    }
    detailGridLoadState = () => { return GridLayout.sendStorageRequest(detailGridKey, "GET", accessToken,null,  this.state.currentLayout); }
    detailGridSaveState = (state) => { GridLayout.sendStorageRequest(detailGridKey, "POST", accessToken, state, this.state.currentLayout); }
    ResetAll(e) {
        if (e != null)
            e.event.stopPropagation();

        this.initialState.receipt.transDate = new Date();
        this.initialState.receipt.recvDate = new Date();
        this.initialState.shipment.transDate = new Date();
        this.initialState.shipment.shipDate = new Date();

        this.setState(this.initialState, () => {
            this.LoadShipmentDropDowns();
        });
    }
    SearchGridFilter(e) {
        e.event.stopPropagation()
        this.LoadItemsGrid();
    }
    ResetGridFilter(e) {
        if (e != null && e != undefined) {
            e.event.stopPropagation()
            this.setState((prvState) => ({
                inventorySelection: {
                    ItemsGridDataFilterCriteria: {
                        Itemcodefrom: "",
                        Itemcodeto: "",
                        Lotcodefrom: "",
                        Lotcodeto: "",
                        Itemdescfrom: "",
                        Itemdescto: "",
                        Lotdescfrom: "",
                        Lotdescto: ""
                    }
                },
                detailTransferQuantityCount: 0,
                selectedRowKeys: [],
                itemGridArr: [],
                selectedgriditems: [],
            }));
            this.LoadItemsGrid();
        }
    }

    DatabaseValueChanged(e) {
        this.setState(prvState => ({
            receipt: {
                profileId: "",
                customerId: "",
                transDate: new Date(),
                transactionNo: "",
                shipperId: "",
                consigneeId: "",
                stage: "P",
                status: "O",
                shipperBolNo: "",
                poReference: "",
                rateScheduleId: "",
                transGroup: "",
                comment: "",
                companyId: "",
                recvDate: new Date(),
                itemProfileId: "",
                transferUnspecifiedSerialNumbers: false,
                receiptDisabled: true,
                databaseId: e.selectedItem?.value
            }
        }));
        this.LoadDatabasesAndCompanyIds(e.selectedItem?.value);
    }
    CompanyIdValueChanged(e) {
        this.setState(prvState => ({
            receipt: {
                ...prvState.receipt,
                profileId: "",
                customerId: "",
                transDate: new Date(),
                transactionNo: "",
                shipperId: "",
                consigneeId: "",
                stage: "",
                status: "",
                shipperBolNo: "",
                poReference: "",
                rateScheduleId: "",
                transGroup: "",
                comment: "",
                recvDate: new Date(),
                itemProfileId: "",
                transferUnspecifiedSerialNumbers: false,
                receiptDisabled: true,
                companyId: e.selectedItem.name
            }
        }));
        this.LoadDatabasesAndCompanyIds(e.selectedItem.value, false);
    }
    ShipmentFormValuesChanged(ctrlName, value) {
        this.setState(prvState => ({
            shipment: {
                ...prvState.shipment,
                [ctrlName]: value
            }
        }));
    }
    ReceiptCustomerValuesChanged(e) {
        if (this.state.shipment.customerId && e.value) {
            if (this.state.shipment.customerId != e.value) {
                this.setState(prvState => ({
                    receipt: {
                        ...prvState.receipt,
                        customerId: e.value
                    }
                }));
            }
            else {
                this.handleShowConfirm();
            }
        }
    }
    handleShowConfirm = () => {
        const confirmationMessage = "Cannot Use The Same Customer For Both Shipment And Receipt Transactions. Please, Select Another Customer.";
        const confirmOptions = {
            title: "Warning",
            message: confirmationMessage,
        };
        confirm(confirmOptions).then((dialogResult) => {
            if (dialogResult) {
                this.setState(prvState => ({
                    receipt: {
                        ...prvState.receipt,
                        ["customerId"]: ""
                    }
                }));
            }
        });
    };
    ReceiptFormValuesChanged(ctrlName, value) {
        this.setState(prvState => ({
            receipt: {
                ...prvState.receipt,
                [ctrlName]: value
            }
        }));
    }
    onEditorPreparing(e) {
        if (e.dataField === 'quantityorder') {
            e.editorOptions.onValueChanged = (args) => {
                const newQuantityOrder = args.value;
                const rowKey = e.row.key;
                const { itemGridArr } = this.state.inventorySelection;
                this.setState((prevState) => {
                    const newKeys = [...prevState.inventorySelection.selectedRowKeys, rowKey];
                    const existingItems = prevState.inventorySelection.selectedgriditems.filter(item => item.key != rowKey);
                    const selectedGridItems = [
                        ...existingItems.filter(item => item.selectedrowkey != rowKey),
                        { selectedrowkey: rowKey, quantityorder: newQuantityOrder }
                    ];
                    const updatedData = itemGridArr.map(row => {
                        if (row.key == rowKey) {
                            return { ...row, quantityorder: newQuantityOrder };
                        }
                        return row;
                    });
                    const totalQuantityOrder = selectedGridItems.reduce((sum, item) => sum + item.quantityorder, 0);
                    return {
                        inventorySelection: {
                            ...prevState.inventorySelection,
                            selectedRowKeys: Array.from(new Set(newKeys)),
                            selectedgriditems: selectedGridItems,
                            detailTransferQuantityCount: totalQuantityOrder,
                            itemGridArr: updatedData
                        }
                    };
                });
            };
        }
    }
    onSelectedRowKeysChange(keys) {
        this.setState((prevState) => ({
            inventorySelection: {
                ...prevState.inventorySelection,
                selectedRowKeys: keys
            }
        }));
    }

    DetailGridselectionChanged({ selectedRowKeys, selectedRowsData, currentSelectedRowKeys, currentDeselectedRowKeys }) {
        const { itemGridArr } = this.state.inventorySelection;
        if (currentDeselectedRowKeys && currentDeselectedRowKeys.length > 0) {
            const updatedData = itemGridArr.map(row => {
                if (currentDeselectedRowKeys.includes(row.key)) {
                    return { ...row, quantityorder: 0 };
                }
                return row;
            });
            this.setState((prevState) => ({
                inventorySelection: {
                    ...prevState.inventorySelection,
                    ...prevState.inventorySelection.ItemsGridDataFilterCriteria,
                    itemGridArr: updatedData
                },
            }));
        }

        this.setState(prevState => {
            const selectedGridItems = selectedRowsData.map(item => ({
                selectedrowkey: item.key,
                quantityorder: item.quantityorder
            }));
            const totalQuantityOrder = selectedGridItems.reduce((sum, item) => sum + item.quantityorder, 0);
            return {
                inventorySelection: {
                    ...prevState.inventorySelection,
                    selectedgriditems: selectedGridItems,
                    detailTransferQuantityCount: totalQuantityOrder
                }
            };
        });
    }
    componentDidMount() {
        this.LoadShipmentDropDowns();
    }
    LoadShipmentDropDowns() {
        this.setState({
            loadIndicatorVisible: true
        });
        Promise.all([
            this.LoadCustomerList('', '', '', false),
            this.LoadShipperList('', '', '', false),
            axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetConsigneeList}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            ).then((response) => {
                let identityDataStore = new DataSource({
                    store: new ArrayStore({
                        data: response.data
                    }),
                    paginate: true,
                    pageSize: 100
                });
                shipmentConsigneeSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                shipmentConsigneeSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }),
            this.LoadRateSchduleList('', '', '', false),
        ]).then(() => {
            this.LoadShipmentProfiles();
        }).catch((err) => {
            this.setState({
                loadIndicatorVisible: false
            });
            notify({
                message: 'Couldnt Load Data!!',
                width: 450,
            }, 'error', 2000);
        });
    }
    LoadShipmentProfiles() {
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetWMProfiles}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                if (response.status == 200) {
                    this.setState(prevState => ({
                        loadIndicatorVisible: false,
                        shipment: {
                            ...prevState.shipment,
                            arrShipmentProfile: response.data,
                        },
                    }));
                }
                else {
                    notify({
                        message: 'Couldnt Load Shipment Profiles ! Refresh the Page.',
                        width: 450,
                    }, 'error', 2000);
                    this.setState(prevState => ({
                        loadIndicatorVisible: false,
                        shipment: {
                            ...prevState.shipment,
                            arrShipmentProfile: [],
                        },
                    }));
                }
            });
    }
    LoadDatabasesAndCompanyIds(selectedDatabaseValue, isRerenderNeeded = true) {
        if (oidc.user.profile.webUserInfo) {
            let webUserInfo = JSON.parse(oidc.user.profile.webUserInfo);
            this.setState({
                loadIndicatorVisible: true
            });
            axios.get(
                `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.GetDatabasesAndCompanies}?userId=${oidc.user.profile.sub}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            )
                .then(async (res) => {
                    var dta = res.data.companies;
                    const selectedRecord = (selectedDatabaseValue != null && selectedDatabaseValue != undefined && selectedDatabaseValue != '') ?
                        dta.find(item => item.value == selectedDatabaseValue) :
                        dta.find(item => item.value == webUserInfo.userCompanyId);
                    const uniqueTexts = new Set(selectedRecord ? [selectedRecord.text] : []);
                    const remainingUniqueArray = dta
                        .filter(item => item.value !== (
                            (selectedDatabaseValue != null && selectedDatabaseValue != undefined && selectedDatabaseValue != '') ?
                                selectedDatabaseValue :
                                webUserInfo.userCompanyId) && !uniqueTexts.has(item.text))
                        .filter(item => {
                            if (!uniqueTexts.has(item.text)) {
                                uniqueTexts.add(item.text);
                                return true;
                            }
                            return false;
                        });
                    const resultArr = await this.fetchData();
                    const filteredCompanyIds = dta
                        .filter(item => item.text == selectedRecord.text)
                        .map(item => ({
                            ...item,
                            id: item.companyname,
                            name: item.companyname
                        }));
                    if (isRerenderNeeded) {
                        let identityDataStore = new DataSource({
                            store: new ArrayStore({
                                data: resultArr
                            }),
                            paginate: true,
                            pageSize: 100
                        });
                        receiptDatabaseSelectBox.current.instance().option(
                            "dataSource",
                            identityDataStore
                        );
                        receiptDatabaseSelectBox.current.instance().option(
                            "acceptCustomValue",
                            false
                        );
                    }
                    Promise.all([
                        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetWMProfiles}?dbName=${selectedRecord.text}&companyid=${selectedRecord.companyname}&userDBId=${selectedRecord.value}`,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`,
                                },
                            }
                        )
                            .then((response) => {
                                let identityDataStore = new DataSource({
                                    store: new ArrayStore({
                                        data: response.data
                                    }),
                                    paginate: true,
                                    pageSize: 100
                                });
                                receiptProfileSelectBox.current.instance().option(
                                    "dataSource",
                                    identityDataStore
                                );
                                receiptProfileSelectBox.current.instance().option(
                                    "acceptCustomValue",
                                    false
                                );
                            }),
                        this.LoadCustomerList(selectedRecord.text, selectedRecord.companyname, selectedRecord.value, true),//selectedRecord.value is id column of UserCompanies table
                        this.LoadShipperList(selectedRecord.text, selectedRecord.companyname, selectedRecord.value, true),
                        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetItemProfiles}?dbName=${selectedRecord.text}&companyid=${selectedRecord.companyname}&userDBId=${selectedRecord.value}`,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`,
                                },
                            }
                        ).then((response) => {
                            let identityDataStore = new DataSource({
                                store: new ArrayStore({
                                    data: response.data
                                }),
                                paginate: true,
                                pageSize: 100
                            });
                            receiptItemProfileSelectBox.current.instance().option(
                                "dataSource",
                                identityDataStore
                            );
                            receiptItemProfileSelectBox.current.instance().option(
                                "acceptCustomValue",
                                false
                            );
                        }),
                        this.LoadRateSchduleList(selectedRecord.text, selectedRecord.companyname, selectedRecord.value, true)
                    ]).then(() => {
                        this.setState((prevState) => ({
                            loadIndicatorVisible: false,
                            receipt: {
                                ...prevState.receipt,
                                databaseId: isRerenderNeeded ? selectedRecord.value : prevState.receipt.databaseId,
                                companyId: selectedRecord?.companyname,
                                dbid: selectedRecord?.value,
                                profileId: "",
                                customerId: "",
                                transDate: new Date(),
                                transactionNo: "",
                                shipperId: "",
                                consigneeId: "",
                                stage: "P",
                                status: "O",
                                shipperBolNo: "",
                                poReference: "",
                                rateScheduleId: "",
                                transGroup: "",
                                comment: "",
                                recvDate: new Date(),
                                itemProfileId: "",
                                transferUnspecifiedSerialNumbers: false,
                                receiptDisabled: true
                            }
                        }));
                    }).catch((err) => {
                        this.setState({
                            loadIndicatorVisible: false
                        });
                        notify({
                            message: 'Couldnt Load Data!!',
                            width: 450,
                        }, 'error', 2000);
                    });
                })
                .catch((err) => {
                    console.log(err, "error while gettng databases");
                    this.setState({
                        loadIndicatorVisible: false
                    });
                }).finally(()=>this.setState({
                            loadIndicatorVisible: false
                        }));
        }
    }
    LoadRateSchduleList(databaseid, companyId, dbid, isReceipt) {
        return axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetRateSchduleList}?dbName=${databaseid}&companyid=${companyId}&userDBId=${dbid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            let identityDataStore = new DataSource({
                store: new ArrayStore({
                    data: response.data
                }),
                paginate: true,
                pageSize: 100
            });
            if (isReceipt) {
                receiptRateSchdSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                receiptRateSchdSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
            else {
                shipmentRateSchdSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                shipmentRateSchdSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
        })

    }
    LoadShipperList(databaseid, companyId, dbid, isReceipt) {

        return axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetShipperList}?dbName=${databaseid}&companyid=${companyId}&userDBId=${dbid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            let identityDataStore = new DataSource({
                store: new ArrayStore({
                    data: response.data
                }),
                paginate: true,
                pageSize: 100
            });
            if (isReceipt) {
                receiptShipperSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                receiptShipperSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
            else {
                shipmentShipperSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                shipmentShipperSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
        });
    }
    LoadCustomerList(databaseid, companyId, userCompanyId, isReceipt) {
        let url=isReceipt?`${routes.OwnerShipTransfer.GetCustomersList}?dbName=${databaseid}&companyId=${companyId}&userCompanyId=${userCompanyId}` : `${routes.OwnerShipTransfer.GetCustomersList}`
        return axios.get(`${window._env_.REACT_APP_APIS}/${url}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            let identityDataStore = new DataSource({
                store: new ArrayStore({
                    data: response.data
                }),
                paginate: true,
                pageSize: 100
            });
            if (isReceipt) {
                receiptCustomerSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                receiptCustomerSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
            else {

                shipmentCustomerSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                shipmentCustomerSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            }
        });
    }
    onTabSelectionChanged(e) {
        const newIndex = e.component.option("selectedIndex");
        this.setState({ selectedTabIndex: newIndex });
        if (newIndex == 1 && !this.state.isReceiptTabLoaded) {
            this.setState({
                isReceiptTabLoaded: true
            });
            this.LoadDatabasesAndCompanyIds();
        }
        else if (newIndex == 2 && !this.state.isInventoryTabLoaded) {
            this.setState({
                isInventoryTabLoaded: true
            });
            this.LoadItemsGrid();
        }
    }
    LoadItemsGrid() {
        this.setState(prevState => ({
            loadIndicatorVisible: true,
        }));
        let Itemcodefrom = this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemcodefrom;
        let Itemcodeto = this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemcodeto;
        let Itemdescfrom = this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemdescfrom;
        let Itemdescto = this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemdescto;
        let Lotcodefrom = this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotcodefrom;
        let Lotcodeto = this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotcodeto;
        let Lotdescfrom = this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotdescfrom;
        let Lotdescto = this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotdescto;
        let Customerid = this.state.shipment.customerId;
        let request = {
            Itemcodefrom: Itemcodefrom,
            Itemcodeto: Itemcodeto,
            Itemdescfrom: Itemdescfrom,
            Itemdescto: Itemdescto,
            Lotcodefrom: Lotcodefrom,
            Lotcodeto: Lotcodeto,
            Lotdescfrom: Lotdescfrom,
            Lotdescto: Lotdescto,
            Rcustomerid: Customerid,
        }
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.LoadOTItemDetailGrid}`, request,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                this.setState(prevState => ({
                    loadIndicatorVisible: false,
                }));
                let rslt = response.data;
                this.setState((prevState) => ({
                    inventorySelection: {
                        ...prevState.inventorySelection,
                        ...prevState.inventorySelection.ItemsGridDataFilterCriteria,
                        itemGridArr: rslt
                    },
                }));
            }).catch((err) => {
                this.setState({
                    loadIndicatorVisible: false
                });
                console.log(err, "Error in loading grid items");
            });
    }
    onApplyClick() {
        if (this.state.shipment.profileId &&
            this.state.shipment.customerId &&
            this.state.shipment.stage &&
            this.state.shipment.status &&
            this.state.shipment.shipDate &&
            this.state.receipt.databaseId &&
            this.state.receipt.companyId &&
            this.state.receipt.customerId &&
            this.state.receipt.profileId &&
            this.state.receipt.stage &&
            this.state.receipt.status &&
            this.state.receipt.recvDate &&
            this.state.receipt.dbid) {
            this.setState(prevState => ({
                loadIndicatorVisible: true,
            }));
            let request = {
                receipt: this.state.receipt,
                shipment: this.state.shipment,
                inventoryselection: {
                    Selectedrowkeys: this.state.inventorySelection.selectedRowKeys,
                    Selectedrowdata: this.state.inventorySelection.selectedgriditems
                }
            }

            request.receipt.transDate = GetFormatedDateWithTime(request.receipt.transDate);
            request.receipt.recvDate = GetFormatedDateWithTime(request.receipt.recvDate);
            request.shipment.transDate = GetFormatedDateWithTime(request.shipment.transDate);
            request.shipment.shipDate = GetFormatedDateWithTime(request.shipment.shipDate);

            axios.post(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.InsertOwnershiptransferInternal}`, request,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            )
                .then((res) => {
                    this.setState({
                        loadIndicatorVisible: false
                    });
                    if (res.data.success) {
                        if (res.data.message)
                            alert('Transactions Created. ' + res.data.message, "Success");

                        this.ResetAll();
                    }
                    else
                        alert('Couldnt Process! : ' + res.data.message, "Error");

                }).catch((err) => {
                    this.setState({
                        loadIndicatorVisible: false
                    });
                    notify({
                        message: 'Some error has occured while processing.',
                        width: 450,
                    }, 'error', 2000);
                });
        }
        else {
            notify({
                message: 'Please enter values in required fields.',
                width: 450,
            }, 'error', 2000);
        }
    }
    onShipmentClickNext() {
        if (this.state.shipment.profileId) {
            this.setState((prevState) => ({
                ...prevState,
                selectedTabIndex: prevState.selectedTabIndex < 2 ? prevState.selectedTabIndex + 1 : prevState.selectedTabIndex
            }));
            if (this.state.selectedTabIndex == 1 && !this.state.isReceiptTabLoaded) {
                this.setState((prevState) => ({
                    ...prevState,
                    isReceiptTabLoaded: true
                }));
                this.LoadDatabasesAndCompanyIds();
            }
        }
        else {
            notify({
                message: 'Please select values in Profile. Thank You !',
                width: 450,
            }, 'info', 2000);
        }
    }
    onReceiptClickNext() {
        if (this.state.shipment.profileId &&
            this.state.shipment.customerId &&
            this.state.receipt.databaseId &&
            this.state.receipt.companyId &&
            this.state.receipt.profileId) {
            this.setState((prevState) => ({
                ...prevState,
                selectedTabIndex: prevState.selectedTabIndex < 2 ? prevState.selectedTabIndex + 1 : prevState.selectedTabIndex
            }));
            if (this.state.selectedTabIndex == 2 && !this.state.isInventoryTabLoaded) {
                this.setState({
                    isInventoryTabLoaded: true
                });
                this.LoadItemsGrid();
            }
        }
        else {
            notify({
                message: 'Please select values in Shipment tab: Profile & Customer & in Receipt tab: Database, Company & Profile. Thank You!',
                width: 450,
            }, 'info', 4000);
        }
    }
    updateFilterCriteria = (field, value) => {
        this.setState(prevState => ({
            inventorySelection: {
                ...prevState.inventorySelection,
                ItemsGridDataFilterCriteria: {
                    ...prevState.inventorySelection.ItemsGridDataFilterCriteria,
                    [field]: value
                }
            }
        }));
    }
    ShipmentCustomerChanged(e) {
        this.setState(prvState => ({
            isInventoryTabLoaded: false,
            shipment: {
                ...prvState.shipment,
                customerId: e.value
            }
        }));
    }
    ShipmentProfileChanged(e) {
        var rowid = e?.selectedItem.id;
        this.setState(prevState => ({
            loadIndicatorVisible: true,
            shipment: {
                ...prevState.shipment,
                profileId: rowid
            }
        }));
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetWMProfilesSettings}?profilerowid=${rowid}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((res) => {
                if (res.data.success) {
                    var rsltDta = res.data.resultdata;
                    this.setState(prvState => ({
                        ...prvState,
                        isTabDisabled: false,
                        shipment: {
                            ...prvState.shipment,
                            profileId: prvState.shipment.profileId,
                            customerId: rsltDta?.rCustomer,
                            transDate: rsltDta?.transactiondate || new Date(),
                            transactionNo: rsltDta?.transactionnumber,
                            shipperId: rsltDta?.rShipper,
                            consigneeId: rsltDta?.rConsignee,
                            stage: rsltDta?.stage || "P",
                            status: rsltDta?.status || "O",
                            shipperBolNo: rsltDta?.shipperbolnumber,
                            poReference: rsltDta?.reference,
                            rateScheduleId: rsltDta?.rRateschedule,
                            transGroup: rsltDta?.transactiongroup,
                            comment: rsltDta?.comment,
                            shipDate: rsltDta?.plannedreceivedshippeddatetime || new Date(),
                            shipmentDisabled: false,
                        }
                    }));
                }
            })
            .catch((err) => {
                console.log(err, "Error in loading Profile");
            }).finally(() => {
                this.setState({
                    loadIndicatorVisible: false
                });
            });
    }
    ReceiptProfileChanged(e) {
        var rowid = e.value;
        this.setState((prevState) => ({
            ...prevState,
            loadIndicatorVisible: true,
            receipt: {
                ...prevState.receipt,
                profileId: e.value
            }
        }));
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetWMProfilesSettings}?profilerowid=${rowid}&dbName=${this.state.receipt.databaseId}&companyid=${this.state.receipt.companyId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((res) => {
                if (res.data.success) {
                    var rsltDta = res.data.resultdata;
                    this.setState(prvState => ({
                        ...prvState,
                        receipt: {
                            ...prvState.receipt,
                            databaseId: prvState.receipt.databaseId,
                            companyId: prvState.receipt.companyId,
                            profileId: prvState.receipt.profileId,
                            customerId: rsltDta?.rCustomer,
                            transDate: rsltDta?.transactiondate || new Date(),
                            transactionNo: rsltDta?.transactionnumber,
                            shipperId: rsltDta?.rShipper,
                            consigneeId: rsltDta?.rConsignee,
                            stage: rsltDta?.stage || "P",
                            status: rsltDta?.status || "O",
                            shipperBolNo: rsltDta?.shipperbolnumber,
                            poReference: rsltDta?.reference,
                            rateScheduleId: rsltDta?.rRateschedule,
                            transGroup: rsltDta?.transactiongroup,
                            comment: rsltDta?.comment,
                            recvDate: rsltDta?.plannedreceivedshippeddatetime || new Date(),
                            receiptDisabled: false,
                            transferUnspecifiedSerialNumbers: false
                        }
                    }));
                }
            })
            .catch((err) => {
                console.log(err, "Error in loading Profile");
            }).finally(() => {
                this.setState({
                    loadIndicatorVisible: false
                });
            });
    }
    AccordionSelectionChanged(e) {
        let newItems = [...this.state.selectedItems];
        e.removedItems.forEach((item) => {
            const index = newItems.indexOf(item);
            if (index >= 0) {
                newItems.splice(index, 1);
            }
        });
        if (e.addedItems.length) {
            newItems = [...newItems, ...e.addedItems];
        }
        this.setState((prevState) => ({
            selectedItems: newItems,
            searchPanelStatus: !prevState.searchPanelStatus,
        }));
    }
    fetchData = async () => {
        try {
            if (oidc.user.profile.webUserInfo) {
                const res = await axios.get(
                    `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.GetDatabasesCompanies}?userId=${oidc.user.profile.sub}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        }
                    }
                );
                if (res.data && res.data.companies.length > 0) {
                    return res.data.companies;

                } else {
                    console.warn("No companies data available.");
                    return null;
                }
            }
        } catch (err) {
            console.log(err, "Error while getting databases");
        }
    };
    render() {
        return (
            <div className="row bg-white">
                <div className="col-md-12">
                    <div id="owner-ship-transfer-internal">
                        <DivLoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            visible={this.state.loadIndicatorVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                            id="ot-internal-loader-indicator"
                        />
                        <ToolbarHdr className="header">
                            <ItemHdr location="before">
                                <div className="title">
                                    <h6
                                        style={{
                                            color: window._env_.Color2,
                                            marginLeft: '12px'
                                        }}
                                    >
                                        Ownership Transfer
                                    </h6>
                                </div>
                            </ItemHdr>
                            <ItemHdr location="after">
                                <Button
                                    text="Apply"
                                    type="default"
                                    className="accordianButton"
                                    onClick={this.onApplyClick}
                                />
                            </ItemHdr>
                            <ItemHdr location="after">
                                <Button
                                    text="Reset"
                                    className="accordianButton"
                                    onClick={this.ResetAll}
                                />
                            </ItemHdr>
                        </ToolbarHdr>
                        <>
                            <div className="AccordionItemBody">
                                <TabPanel stylingMode={'secondary'}
                                    selectedIndex={this.state.selectedTabIndex}
                                    onSelectionChanged={this.onTabSelectionChanged}
                                    className="TabpanelContainer">
                                    <TabPanelItem title="Shipment" disabled={false}>
                                        <div className="row pt-3">
                                            <div className="col-md-3">
                                                <SelectBox
                                                    dataSource={this.state.shipment.arrShipmentProfile}
                                                    searchEnabled={true}
                                                    placeholder="Enter Profile"
                                                    onSelectionChanged={this.ShipmentProfileChanged}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    className="owner-ship-transfer-internal-dropdown"
                                                    acceptCustomValue={true}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Profile:"
                                                    value={this.state.shipment.profileId}
                                                    elementAttr={{
                                                        class: !this.state.shipment.profileId ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentCustomerSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Customer"
                                                    onValueChanged={this.ShipmentCustomerChanged}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    value={this.state.shipment.customerId}
                                                    acceptCustomValue={true}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Customer:"
                                                    elementAttr={{
                                                        class: !this.state.shipment.customerId ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <DateBox
                                                    value={this.state.shipment.transDate}
                                                    min={new Date(1900, 0, 1)}
                                                    max={new Date(2099, 12, 31)}
                                                    type="datetime"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("transDate", e.value)}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Trans Date:"
                                                    elementAttr={{
                                                        class: !this.state.shipment.transDate ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="shipment-transaction-no"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Transaction No."
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("transactionNo", e.value)}
                                                    name="shipment-trans-No"
                                                    value={this.state.shipment.transactionNo}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Transaction #:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentShipperSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Shipper"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("shipperId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.shipment.shipperId}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Shipper:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentConsigneeSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Consignee"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("consigneeId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.shipment.consigneeId}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Consignee:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentStageSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Stage"
                                                    items={this.arrStage}
                                                    displayExpr="name"
                                                    valueExpr="value"
                                                    acceptCustomValue={true}
                                                    value={this.state.shipment.stage}
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("stage", e.value)}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Stage:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentStatusSelectBox}
                                                    items={this.arrStatus}
                                                    searchEnabled={true}
                                                    placeholder="Enter Status"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("status", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="value"
                                                    acceptCustomValue={true}
                                                    value={this.state.shipment.status}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Status:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <DateBox
                                                    value={this.state.shipment.shipDate}
                                                    min={new Date(2000, 0, 1)}
                                                    max={new Date(2099, 12, 31)}
                                                    type="datetime"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("shipDate", e.value)}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Ship Date:"
                                                    elementAttr={{
                                                        class: !this.state.shipment.shipDate ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="shipment-shipper-no"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Shipper #"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("shipperBolNo", e.value)}
                                                    name="shipment-shipper-no"
                                                    value={this.state.shipment.shipperBolNo}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Shipper #:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="shipment-po-reference"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter PO Reference"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("poReference", e.value)}
                                                    name="shipment-po-ref"
                                                    value={this.state.shipment.poReference}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="PO Reference:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={shipmentRateSchdSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Rate Schedule"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("rateScheduleId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.shipment.rateScheduleId}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Rate Schedule:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="shipment-transaction-Group"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Trans Group"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("transGroup", e.value)}
                                                    name="shipment-trans-group"
                                                    value={this.state.shipment.transGroup}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Trans Group:"
                                                />
                                            </div>
                                            <div className="col-md-9">
                                                <TextArea
                                                    id="shipment-comment"
                                                    className="input-field"
                                                    placeholder="Enter Comment"
                                                    onValueChanged={(e) => this.ShipmentFormValuesChanged("comment", e.value)}
                                                    name="shipment-comment"
                                                    value={this.state.shipment.comment}
                                                    disabled={this.state.shipment.shipmentDisabled}
                                                    height={90}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Comment:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="row">
                                                <div className="col-md-12 my-2">
                                                    <Button
                                                        text="Next"
                                                        type="default"
                                                        stylingMode="contained"
                                                        onClick={this.onShipmentClickNext}
                                                    /></div>
                                            </div>
                                        </div>
                                    </TabPanelItem>
                                    <TabPanelItem title="Receipt"
                                        disabled={this.state.isTabDisabled}>
                                        <div className="row pt-3">
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptDatabaseSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Facility"
                                                    onSelectionChanged={this.DatabaseValueChanged}
                                                    displayExpr="text"
                                                    valueExpr="value"
                                                    value={this.state.receipt.databaseId}
                                                    acceptCustomValue={true}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Select Facility:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.databaseId ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptProfileSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Profile"
                                                    onValueChanged={this.ReceiptProfileChanged}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.receipt.profileId}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Profile:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.profileId ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptCustomerSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Customer"
                                                    onValueChanged={this.ReceiptCustomerValuesChanged}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    value={this.state.receipt.customerId}
                                                    acceptCustomValue={true}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Customer:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.customerId ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <DateBox
                                                    value={this.state.receipt.transDate}
                                                    min={new Date(2000, 0, 1)}
                                                    max={new Date(2099, 12, 31)}
                                                    type="datetime"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("transDate", e.value)}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Trans Date:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="receipt-transaction-no"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Transaction No."
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("transactionNo", e.value)}
                                                    name="receipt-trans-No"
                                                    value={this.state.receipt.transactionNo}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Transaction #:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptShipperSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Shipper"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("shipperId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    value={this.state.receipt.shipperId}
                                                    acceptCustomValue={true}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Shipper:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptConsigneeSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Consignee"
                                                    onValueChanged={null}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={""}
                                                    disabled={true}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Consignee:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <SelectBox
                                                    items={this.arrStage}
                                                    displayExpr="name"
                                                    valueExpr="value"
                                                    ref={receiptStageSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Stage"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("stage", e.value)}
                                                    acceptCustomValue={true}
                                                    value={this.state.receipt.stage}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Stage:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.stage ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptStatusSelectBox}
                                                    items={this.arrStatus}
                                                    searchEnabled={true}
                                                    placeholder="Enter Status"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("status", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="value"
                                                    acceptCustomValue={true}
                                                    value={this.state.receipt.status}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Status:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.status ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <DateBox
                                                    value={this.state.receipt.recvDate}
                                                    min={new Date(2000, 0, 1)}
                                                    max={new Date(2099, 12, 31)}
                                                    type="datetime"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("recvDate", e.value)}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Rec Date:"
                                                    elementAttr={{
                                                        class: !this.state.receipt.recvDate ? "field-label-required-red" : "",
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="receipt-shipper-no"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Shipper #"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("shipperBolNo", e.value)}
                                                    name="receipt-shipper-no"
                                                    value={this.state.receipt.shipperBolNo}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Shipper #:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="receipt-po-reference"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter PO Reference"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("poReference", e.value)}
                                                    name="shipment-po-ref"
                                                    value={this.state.receipt.poReference}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="PO Reference:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptRateSchdSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Rate Schedule"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("rateScheduleId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.receipt.rateScheduleId}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Rate Schedule:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <TextBox
                                                    id="receipt-transaction-Group"
                                                    className="input-field"
                                                    type="text"
                                                    placeholder="Enter Trans Group"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("transGroup", e.value)}
                                                    name="receipt-trans-group"
                                                    value={this.state.receipt.transGroup}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Trans Group:"
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <SelectBox
                                                    ref={receiptItemProfileSelectBox}
                                                    searchEnabled={true}
                                                    placeholder="Enter Item Profile"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("itemProfileId", e.value)}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    acceptCustomValue={true}
                                                    value={this.state.receipt.itemProfileId}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Item Profile:"
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-9">
                                                <TextArea
                                                    id="receipt-comment"
                                                    className="input-field"
                                                    placeholder="Enter Comment"
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("comment", e.value)}
                                                    name="shipment-comment"
                                                    value={this.state.receipt.comment}
                                                    height={90}
                                                    disabled={this.state.receipt.receiptDisabled}
                                                    stylingMode='outlined'
                                                    labelMode="static"
                                                    label="Comment:"
                                                />
                                            </div>
                                            <div className="col-md-3 mt-4">
                                                <CheckBox
                                                    defaultValue={this.state.receipt.transferUnspecifiedSerialNumbers}
                                                    onValueChanged={(e) => this.ReceiptFormValuesChanged("transferUnspecifiedSerialNumbers", e.value)}
                                                    text="Transfer all unspecified Serial Numbers"
                                                    className="mr-2"
                                                    disabled={this.state.receipt.receiptDisabled}
                                                />
                                            </div>
                                        </div>
                                        <div className="row accordianLastRow">
                                            <div className="col-md-12 my-2">
                                                <Button
                                                    text="Next"
                                                    type="default"
                                                    stylingMode="contained"
                                                    onClick={this.onReceiptClickNext}
                                                /></div>
                                        </div>
                                    </TabPanelItem>
                                    <TabPanelItem title="Select Inventory"
                                        disabled={!this.state.shipment.customerId}>
                                        <div className="row pt-3">
                                            <div className="col-md-6">
                                                <div
                                                    style={{
                                                        color: window._env_.Color2,
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                    }}>
                                                    Transfer Totals: <span className="pl-1 d-inline-block text-secondary">{this.state.inventorySelection.detailTransferQuantityCount}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 main-page" >
                                                <div id="accordion" >
                                                    <Accordion
                                                        dataSource={this.searchpanel}
                                                        className="accordion-height"
                                                        collapsible={true}
                                                        multiple={false}
                                                        animationDuration={300}
                                                        selectedItems={this.state.selectedItems}
                                                        onSelectionChanged={e => {
                                                            if (e.currentTarget === e.target) {
                                                                this.AccordionSelectionChanged(e);
                                                            }
                                                        }}
                                                        itemTitleRender={() => (
                                                            <ToolbarHdr className="accordian-toolbar">
                                                                <ItemHdr location="before">
                                                                    <div className="title">
                                                                        <h6
                                                                            style={{
                                                                                color: window._env_.Color2
                                                                            }}
                                                                        >
                                                                            Filter Criteria
                                                                        </h6>
                                                                    </div>
                                                                </ItemHdr>
                                                                <ItemHdr location="after">
                                                                    <Button className="accordianButton" onClick={this.SearchGridFilter} type="default" text="Search" />
                                                                </ItemHdr>
                                                                <ItemHdr location="after">
                                                                    <Button className="accordianButton" onClick={this.ResetGridFilter} text="Reset" />
                                                                </ItemHdr>
                                                            </ToolbarHdr>
                                                        )}
                                                        itemRender={(itemProps) => (
                                                            <div>
                                                                <div className="row">
                                                                    <div className="col-md-3">
                                                                        <TextBox
                                                                            label="Item Code From:"
                                                                            value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemcodefrom}
                                                                            onValueChanged={(data) => this.updateFilterCriteria('Itemcodefrom', data.value)}
                                                                            stylingMode='outlined'
                                                                            labelMode="static"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <TextBox
                                                                            label="Item Code To:"
                                                                            value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemcodeto}
                                                                            onValueChanged={(data) => this.updateFilterCriteria('Itemcodeto', data.value)}
                                                                            stylingMode='outlined'
                                                                            labelMode="static"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <TextBox
                                                                            label="Lot Code From:"
                                                                            value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotcodefrom}
                                                                            onValueChanged={(data) => this.updateFilterCriteria('Lotcodefrom', data.value)}
                                                                            stylingMode='outlined'
                                                                            labelMode="static"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <TextBox
                                                                            label="Lot Code To:"
                                                                            value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotcodeto}
                                                                            onValueChanged={(data) => this.updateFilterCriteria('Lotcodeto', data.value)}
                                                                            stylingMode='outlined'
                                                                            labelMode="static"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="row accordianLastRow">
                                                                    <div className="col-md-3">
                                                                        <TextBox
                                                                            label="Item Desc From:"
                                                                            value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemdescfrom}
                                                                            onValueChanged={(data) => this.updateFilterCriteria('Itemdescfrom', data.value)}
                                                                            stylingMode='outlined'
                                                                            labelMode="static"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <TextBox
                                                                            label="Item Desc To:"
                                                                            value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Itemdescto}
                                                                            onValueChanged={(data) => this.updateFilterCriteria('Itemdescto', data.value)}
                                                                            stylingMode='outlined'
                                                                            labelMode="static"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <TextBox
                                                                            label="Lot Desc From:"
                                                                            value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotdescfrom}
                                                                            onValueChanged={(data) => this.updateFilterCriteria('Lotdescfrom', data.value)}
                                                                            stylingMode='outlined'
                                                                            labelMode="static"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <TextBox
                                                                            label="Lot Desc To:"
                                                                            value={this.state.inventorySelection.ItemsGridDataFilterCriteria.Lotdescto}
                                                                            onValueChanged={(data) => this.updateFilterCriteria('Lotdescto', data.value)}
                                                                            stylingMode='outlined'
                                                                            labelMode="static"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        id="accordion-container"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                                                ref={detailOTItemDataGrid}
                                                dataSource={this.state.inventorySelection.itemGridArr}
                                                keyExpr="key"
                                                className={this.state.searchPanelStatus ? "GridHeightAccordianOpen-tabs-with-toolbar" : "GridHeightAccordianClose-tabs-with-toolbar"}
                                                hoverStateEnabled={true}
                                                allowColumnResizing={true}
                                                allowColumnReordering={true}
                                                onSelectionChanged={(e) => this.DetailGridselectionChanged(e)}
                                                selectedRowKeys={this.state.inventorySelection.selectedRowKeys}
                                                onEditorPreparing={this.onEditorPreparing}
                                                onSelectedRowKeysChange={this.onSelectedRowKeysChange}
                                                showBorders={true}
                                            >
                                                <ColumnChooser
                                                    enabled={true}
                                                    title="Choose Column"
                                                    width={290}
                                                    height={290}
                                                    sortOrder="asc"
                                                >
                                                    <ColumnChooserSearch
                                                        enabled={true}
                                                        editorOptions={{ placeholder: 'Search column' }} />
                                                </ColumnChooser>
                                                <Selection mode="multiple" />
                                                <ColumnHeaderFilter />
                                                <Export enabled={true} allowExportSelectedData={true} text="Export" />
                                                <Sorting visible={true} mode="multiple" />
                                                <LoadPanel enabled={true} />
                                                <Paging defaultPageSize={10} />
                                                <Pager
                                                    visible={true}
                                                    showPageSizeSelector={true}
                                                    allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                                                    showNavigationButtons={true}
                                                />
                                                <FilterRow visible={true} />
                                                <FilterPanel visible={true} />
                                                <HeaderFilter enabled={true} visible={false} />
                                                <Editing mode="cell" allowUpdating={true} refreshMode="repaint" />
                                                <GroupPanel visible={true} />
                                                <Grouping autoExpandAll={false} />
                                                <StateStoring
                                                    enabled={true}
                                                    type="custom"
                                                    customLoad={this.detailGridLoadState}
                                                    storageKey={detailGridKey}
                                                    customSave={this.detailGridSaveState}
                                                />
                                                <Scrolling rowRenderingMode="virtual" />
                                                <LoadPanel enabled={true} />
                                                <Column
                                                    dataField="quantityorder"
                                                    dataType="number"
                                                    caption="Quantity"
                                                ></Column>
                                                <Column
                                                    dataField="itemcode"
                                                    caption="Item"
                                                    allowEditing={false}
                                                ></Column>
                                                <Column
                                                    dataField="itemdescription"
                                                    caption="Item Description"
                                                    allowEditing={false}
                                                ></Column>
                                                <Column dataField="lotcode" caption="Lot" allowEditing={false}></Column>
                                                <Column
                                                    dataField="lotdescription"
                                                    caption="Lot Description"
                                                    allowEditing={false}
                                                ></Column>
                                                <Column
                                                    dataField="classcode"
                                                    caption="Class"
                                                    allowEditing={false}
                                                    visible={false}
                                                ></Column>
                                                <Column
                                                    dataField="palletsizecode"
                                                    caption="PalletSizeCode"
                                                    allowEditing={false}
                                                    visible={false}
                                                ></Column>
                                                <Column
                                                    dataField="subclasscode"
                                                    caption="SubClass"
                                                    allowEditing={false}
                                                    visible={false}
                                                ></Column>
                                                <Column
                                                    dataField="netavailable"
                                                    caption="Item Net Avl"
                                                    allowEditing={false}
                                                ></Column>
                                                <Column
                                                    dataField="lotnetavailable"
                                                    caption="Lot Net Avl"
                                                    allowEditing={false}
                                                ></Column>
                                                <Toolbar>
                                                    <Item location="after">
                                                        <GridLayoutManager
                                                            gridKey={detailGridKey}
                                                            dataGrid={detailOTItemDataGrid}
                                                            setCurrentLayout={this.setCurrentLayout} />
                                                    </Item>
                                                    <Item name="exportButton" />
                                                    <Item name="columnChooserButton" />
                                                </Toolbar>
                                            </DataGrid>
                                        </div>
                                    </TabPanelItem>
                                </TabPanel>
                            </div>
                        </>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(OwnershipTransferInternal);